import { Injectable } from '@angular/core';

@Injectable()
export class AdminVaccineService {
    constructor() {
    }
}
export const typeVaccination = {
    vaccinationsReceived: 1,
    futureVaccinations: 2,
    vaccinationsReceivedThirdParty: 3
};



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/admin-vaccine/admin-vaccine.service.ts